import '../../scripts/common';

import '../../scripts/autosize';
import '../../scripts/animate';
import '../../scripts/picture';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Field from '../../components/base/Field';
import PageScrollBtn from '../../components/simple/PageScrollBtn';
import Spinner from '../../components/base/Spinner';
import Radio from '../../components/base/Radio';
import Tabs from '../../components/base/Tabs';
import Checkbox from '../../components/base/Checkbox';

// Carousel
import Carousel from '../../components/base/Carousel';
import AboutSlide from '../../components/AboutSlide';
import AboutTabs from '../../components/simple/AboutTabs';

import { media } from '../../scripts/helpers';

import '../../images/sprite/iso14001.svg';
import '../../images/sprite/iso26000.svg';
import '../../images/sprite/med.svg';

import '../../images/sprite/dermatologists.svg';
import '../../images/sprite/continents.svg';
import '../../images/sprite/countries.svg';
import '../../images/sprite/products_france.svg';
import '../../images/sprite/factory_france.svg';
import '../../images/sprite/farmlands.svg';

import '../../images/sprite/service_delivery.svg';
import '../../images/sprite/service_diagnostic.svg';
import '../../images/sprite/service_example.svg';
import '../../images/sprite/service_pay.svg';
import '../../images/sprite/service_personal.svg';
import '../../images/sprite/service_support.svg';

import './styles.css';

$(() => {
    Header.create();
    Footer.create();
    Field.create();
    Spinner.create();
    Radio.create();
    PageScrollBtn.create();
    Tabs.create();
    Checkbox.create();
    AboutTabs.create();
    initCarousel();
    AboutSlide.create();
});

function initCarousel() {
    const carouselAboutIconObj = new Carousel($('.carousel--about-icons'));
    carouselAboutIconObj.init({
        destroyMode: 'next',
        destroyBreakpoint: media('tablet'),
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        slidesPerView: 1,
        loop: false,
        centeredSlides: true,
    });

    const carouselAboutProgressObj = new Carousel($('.carousel--about-progress'));
    carouselAboutProgressObj.init({
        destroyMode: 'next',
        destroyBreakpoint: media('tablet'),
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        slidesPerView: 1,
        loop: false,
        centeredSlides: true,
    });

    const carouselAboutpageObj = new Carousel($('.carousel--aboutslide'));
    carouselAboutpageObj.init({
        loop: true,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
    });
}
